import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { isJapanese } from '../../../../../../utils/lang';
import ExternalLink from '../../../../../common/Footer/ExternalLink';

/**
 * 旅CUBEの利用規約ページへのリンクのコンポーネント。
 */
const Terms: React.FC = () => {
  const { t, i18n } = useTranslation();
  /** 日本語版のURL。 */
  const urlJa = 'https://tabicube.com/web/ja/terms';
  /** 英語版のURL。 */
  const urlEn = 'https://tabicube.com/web/en/terms';
  /** リンクとして設定するURL。 */
  // 言語設定に応じてリンク先を切り替える。
  const url = isJapanese(i18n.language) ? urlJa : urlEn;
  return (<ExternalLink url={url} label={t('terms')} />);
};

export default Terms;
